import { useEffect, type Dispatch, type SetStateAction } from "react";

import type { TravelersState } from "@/lib/cart/types";

import type { PaxCategory } from "./_capacity";
import { fitPartyToCap } from "./_traveler-picker";

/** Keeps the picked party inside the picker cap. The seed puts one of the
 *  default category in the party, and when that step alone is bigger than the
 *  tour (a Private Group of 6 on a 2-seat tour) checkout would refuse it and
 *  the picker could not leave it. The party starts on the first category that
 *  fits instead (`fitPartyToCap`). */
export function useFitPartyToCap(args: {
  travelers: TravelersState;
  categories: ReadonlyArray<PaxCategory>;
  defaultCatId: string | undefined;
  pickerCap: number | null;
  setTravelers: Dispatch<SetStateAction<TravelersState>>;
}): void {
  const { travelers, categories, defaultCatId, pickerCap, setTravelers } = args;
  useEffect(() => {
    setTravelers((prev) =>
      fitPartyToCap({
        travelers: prev,
        categories,
        preferredId: defaultCatId,
        pickerCap,
      }),
    );
  }, [travelers, categories, defaultCatId, pickerCap, setTravelers]);
}
